import * as React from 'react';
import { observer } from 'mobx-react';
import { DataTableView } from 'src/core/ui/data-table.view';
import { ToastNotifications } from 'src/core/ui/toast';
import { Link } from 'react-router-dom';

/**
 *  Principal Grid of Allotments
 */
interface AllotmentListViewProps extends ComponentViewProps<DataSet<AllotmentSummary>> {
	filtersView?: React.ReactElement<any>;
	onItemDoubleClicked?: (item: AllotmentSummary) => any;
	toast: ToastNotifications;
	deleteAllotment: (items: any[]) => Promise<void>;
}

@observer
export class AllotmentListView extends React.Component<AllotmentListViewProps, {}> {
	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		const columns = [
			{
				key: 'name',
				title: 'Name',
				dataIndex: 'name',
				render: (text, record: AllotmentSummary) => <Link to={`/products/allotment/${record.id}`}>{text}</Link>,
			}
		];

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={columns}
						model={model}
						afterDeleteItem={this.props.deleteAllotment}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }}
						hierarchyParent={['parentAllotmentId']}
						hierarchyHasChildren={(item) => item.hasChildren}
						hierarchyId={['id']}
					/>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/allotment/list/allotment-list.view.tsx